/** InsCoder 2026-08-04 B + Pavé option selection and cart child replacement **/
(function(window, document) {
  'use strict';

  var storageKey = 'kavalri:pave-option';
  var catalogStorageKey = 'kavalri:pave-options';
  var optionDefaults = [
    'No Pavé Bridge',
    '1 Side · Lab Diamond $350',
    '1 Side · Natural Diamond $450',
    'Both Sides · Lab Diamond $550',
    'Both Sides · Natural Diamond $700'
  ];

  function parseOptions(value) {
    try {
      var options = JSON.parse(value || '[]');
      return Array.isArray(options) ? options : [];
    } catch (error) {
      return [];
    }
  }

  function readSelection() {
    try {
      var selection = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      if (!selection || !selection.option_key || !selection.variant_id) {
        return null;
      }
      return selection;
    } catch (error) {
      return null;
    }
  }

  function readProductPickerSelection() {
    var pickerSelection = null;

    document.querySelectorAll('[data-pave-option-picker]').forEach(function(wrapper) {
      if (pickerSelection) {
        return;
      }

      var select = wrapper.querySelector('[data-pave-option-select]');
      var options = parseOptions(wrapper.dataset.paveOptions);
      if (!select || !options.length) {
        return;
      }

      var selectedOption = options.filter(function(option) {
        return String(option.key) === String(select.value);
      })[0];

      if (!selectedOption || !selectedOption.variant_id || selectedOption.available === false) {
        return;
      }

      pickerSelection = {
        option_key: String(selectedOption.key),
        title: selectedOption.title,
        variant_id: Number(selectedOption.variant_id),
        product_handle: selectedOption.product_handle || '',
        image: selectedOption.image || '',
        options: options
      };
    });

    return pickerSelection;
  }

  function getSelection() {
    return readSelection() || readProductPickerSelection();
  }

  function saveSelection(selection) {
    if (!selection || !selection.variant_id) {
      window.localStorage.removeItem(storageKey);
      return;
    }
    window.localStorage.setItem(storageKey, JSON.stringify(selection));
  }

  function readOptionsCatalog() {
    try {
      return parseOptions(window.localStorage.getItem(catalogStorageKey));
    } catch (error) {
      return [];
    }
  }

  function saveOptionsCatalog(options) {
    if (!Array.isArray(options) || !options.length) {
      return;
    }
    window.localStorage.setItem(catalogStorageKey, JSON.stringify(options));
  }

  function getCartOptions(lineItem) {
    var lineOptions = parseOptions(lineItem.dataset.cartChildOptions || lineItem.dataset.paveOptions);
    var catalogOptions = readOptionsCatalog();

    return optionDefaults.map(function(defaultTitle, optionIndex) {
      var optionKey = String(optionIndex + 1);
      var lineOption = lineOptions.filter(function(option) {
        return String(option.key) === optionKey;
      })[0];
      var catalogOption = catalogOptions.filter(function(option) {
        return String(option.key) === optionKey;
      })[0];

      return lineOption || catalogOption || {
        key: optionKey,
        title: defaultTitle,
        variant_id: 0,
        available: false
      };
    });
  }

  function getOptionPresentation(option) {
    var sourceTitle = option && option.title ? String(option.title) : 'Pavé Diamond Bridge';
    var subtitle = '';
    var displayTitle = sourceTitle.replace(/\s+\$[\d,.]+(?:\s+[A-Z]{3})?$/i, '').trim();

    if (/natural diamond/i.test(sourceTitle)) {
      subtitle = 'Natural Diamond';
    } else if (/lab diamond/i.test(sourceTitle)) {
      subtitle = 'Lab Diamond';
    }

    if (/both sides/i.test(sourceTitle)) {
      displayTitle = 'Pavé Diamond Bridge — Both Sides';
    } else if (/1 side|one side/i.test(sourceTitle)) {
      displayTitle = 'Pavé Diamond Bridge — One Side';
    }

    return {
      title: displayTitle,
      subtitle: subtitle,
      image: option && option.image ? String(option.image) : ''
    };
  }

  function getOptionSelectTitle(option) {
    var title = option && option.title ? String(option.title) : '';
    var formattedPrice = '';

    if (option && option.variant_id && Number.isFinite(Number(option.price)) &&
        window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      formattedPrice = window.theme.Currency.formatMoney(Number(option.price), window.theme.settings.moneyFormat);
    }

    return formattedPrice ? title + ' · ' + formattedPrice : title;
  }

  function setPreview(wrapper, option) {
    var image = wrapper.querySelector('[data-pave-option-image]');
    if (!image) {
      return;
    }

    image.innerHTML = '';
    if (option && option.image) {
      var imageElement = document.createElement('img');
      imageElement.src = option.image;
      imageElement.width = 69;
      imageElement.height = 73;
      imageElement.loading = 'lazy';
      imageElement.alt = option.title || 'Pavé Diamond Bridge';
      image.appendChild(imageElement);
    }
  }

  /** InsCoder 2026-09-02 B + Add the selected Pavé product price to the current main variant price. **/
  function getSelectedOption(select, options) {
    return options.filter(function(option) {
      return String(option.key) === String(select.value);
    })[0] || options[0];
  }

  function updateDisplayedProductPrice(wrapper, selectedOption) {
    var productSection = wrapper.closest('.product-section');
    var priceElement = productSection && productSection.querySelector('[data-product-price]');
    var basePrice = Number(wrapper.dataset.paveBasePrice);
    var addOnPrice = selectedOption && selectedOption.variant_id && selectedOption.available !== false
      ? Number(selectedOption.price)
      : 0;

    if (!priceElement || !Number.isFinite(basePrice) || !Number.isFinite(addOnPrice) ||
        !window.theme || !window.theme.Currency || typeof window.theme.Currency.formatMoney !== 'function') {
      return;
    }

    priceElement.innerHTML = window.theme.Currency.formatMoney(
      basePrice + addOnPrice,
      window.theme.settings.moneyFormat
    );
  }
  /** InsCoder 2026-09-02 E + Add the selected Pavé product price to the current main variant price. **/

  function updateProductPicker(wrapper, select, options) {
    var selectedOption = getSelectedOption(select, options);

    if (!selectedOption) {
      return;
    }

    saveOptionsCatalog(options);
    select.value = String(selectedOption.key);
    setPreview(wrapper, selectedOption);
    updateDisplayedProductPrice(wrapper, selectedOption);
    if (selectedOption.variant_id && selectedOption.available !== false) {
      saveSelection({
        option_key: String(selectedOption.key),
        title: selectedOption.title,
        variant_id: Number(selectedOption.variant_id),
        product_handle: selectedOption.product_handle || '',
        image: selectedOption.image || '',
        options: options
      });
    } else {
      saveSelection(null);
    }
  }

  function initProductPickers() {
    document.querySelectorAll('[data-pave-option-picker]').forEach(function(wrapper) {
      var select = wrapper.querySelector('[data-pave-option-select]');
      if (!select || wrapper.dataset.paveInitialized === 'true') {
        return;
      }

      var options = parseOptions(wrapper.dataset.paveOptions);
      if (!options.length) {
        return;
      }

      wrapper.dataset.paveInitialized = 'true';
      var savedSelection = readSelection();
      if (savedSelection && options.some(function(option) {
        return String(option.key) === String(savedSelection.option_key);
      })) {
        select.value = String(savedSelection.option_key);
      }

      updateProductPicker(wrapper, select, options);
      select.addEventListener('change', function() {
        updateProductPicker(wrapper, select, options);
      });

      var productSection = wrapper.closest('.product-section');
      if (productSection) {
        productSection.addEventListener('variantChange', function(event) {
          var variant = event.detail && event.detail.variant;
          if (!variant || !Number.isFinite(Number(variant.price))) {
            return;
          }

          wrapper.dataset.paveBasePrice = String(variant.price);
          window.setTimeout(function() {
            updateDisplayedProductPrice(wrapper, getSelectedOption(select, options));
          }, 0);
        });
      }
    });
  }

  function dispatchCartBuild() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function rejectCartRequest(response, fallbackMessage) {
    var error = new Error(fallbackMessage);
    error.status = response.status;

    return response.json().catch(function() {
      return {};
    }).then(function(payload) {
      error.message = payload.description || payload.message || fallbackMessage;
      throw error;
    });
  }

  function notifyCartRequestError(error) {
    if (error && Number(error.status) === 429 && typeof window.alert === 'function') {
      window.alert('Too many requests right now. Please wait a moment and try again.');
    } else if (error && Number(error.status) === 400 && typeof window.alert === 'function') {
      window.alert('The bridge option could not be updated. Please try again.');
    }

    window.console && window.console.error(error);
  }

  function getLatestCartItemKey(lineItem, expectedKey) {
    var cartUrl = window.theme && window.theme.routes && window.theme.routes.cart
      ? window.theme.routes.cart
      : '/cart.js';
    var separator = cartUrl.indexOf('?') === -1 ? '?' : '&';
    var bundleId = lineItem.dataset.cartBundleId || lineItem.dataset.paveBundleId;
    var optionKey = lineItem.dataset.cartChildOptionKey || lineItem.dataset.paveOptionKey;

    return fetch(cartUrl + separator + 't=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      if (!response.ok) {
        return rejectCartRequest(response, 'Unable to refresh the cart.');
      }
      return response.json();
    }).then(function(cart) {
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      var exactItem = items.filter(function(item) {
        return String(item.key) === String(expectedKey);
      })[0];

      if (exactItem) {
        return exactItem.key;
      }

      var matchingItem = items.filter(function(item) {
        var properties = item.properties || {};
        var itemBundleId = properties._cart_bundle_id || properties._pave_bundle_id;
        var itemOptionKey = properties._cart_child_option_key || properties._pave_option_key;
        return String(itemBundleId) === String(bundleId) && String(itemOptionKey) === String(optionKey);
      })[0];

      return matchingItem ? matchingItem.key : '';
    });
  }

  function changeCartItemWithRecovery(lineItem, key, quantity) {
    return changeCartItem(key, quantity).catch(function(error) {
      if (Number(error.status) !== 400) {
        throw error;
      }

      return getLatestCartItemKey(lineItem, key).then(function(latestKey) {
        if (!latestKey || String(latestKey) === String(key)) {
          throw error;
        }
        return changeCartItem(latestKey, quantity);
      });
    });
  }

  function addCartItem(item) {
    return fetch(window.theme && window.theme.routes ? window.theme.routes.cartAdd : '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [item] })
    }).then(function(response) {
      if (!response.ok) {
        return rejectCartRequest(response, 'Unable to add the Pavé option.');
      }
      return response.json();
    });
  }

  function changeCartItem(key, quantity) {
    return fetch(window.theme && window.theme.routes ? window.theme.routes.cartChange : '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(response) {
      if (!response.ok) {
        return rejectCartRequest(response, 'Unable to update the Pavé option.');
      }
      return response.json();
    });
  }

  function populateCartSelect(lineItem) {
    var select = lineItem.querySelector('[data-cart-change-select]');
    if (!select || select.dataset.cartOptionsReady === 'true') {
      return;
    }

    var options = getCartOptions(lineItem);
    var currentKey = lineItem.dataset.cartChildOptionKey || lineItem.dataset.paveOptionKey;
    select.innerHTML = '';
    options.forEach(function(option) {
      var optionElement = document.createElement('option');
      optionElement.value = String(option.key);
      optionElement.textContent = getOptionSelectTitle(option) || option.product_title || '';
      optionElement.dataset.variantId = option.variant_id || '';
      if (String(option.key) !== '1' && (!option.variant_id || option.available === false)) {
        optionElement.disabled = true;
      }
      if (String(option.key) === String(currentKey)) {
        optionElement.selected = true;
      }
      select.appendChild(optionElement);
    });
    select.dataset.cartOptionsReady = 'true';
  }

  function setCartChangeState(change, isActive) {
    if (!change) {
      return;
    }

    change.classList.toggle('is-active', isActive);
    var toggle = change.querySelector('[data-cart-change-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    }
  }

  function replaceCartChild(lineItem, select) {
    if (!lineItem || !select || lineItem.dataset.paveUpdating === 'true' || select.disabled) {
      return;
    }

    var options = getCartOptions(lineItem);
    var nextOption = options.filter(function(option) {
      return String(option.key) === String(select.value);
    })[0];
    var currentKey = lineItem.dataset.key;
    var bundleId = lineItem.dataset.cartBundleId || lineItem.dataset.paveBundleId;
    var parentVariantId = lineItem.dataset.cartParentVariantId || lineItem.dataset.paveParentVariantId;
    var change = select.closest('[data-cart-change]');
    var currentOptionKey = lineItem.dataset.cartChildOptionKey || lineItem.dataset.paveOptionKey;

    if (!nextOption || !currentKey || !bundleId) {
      if (change) {
        setCartChangeState(change, false);
      }
      return;
    }

    if (String(nextOption.key) === String(currentOptionKey)) {
      if (change) {
        setCartChangeState(change, false);
      }
      return;
    }

    if (String(nextOption.key) === '1') {
      lineItem.dataset.paveUpdating = 'true';
      select.disabled = true;
      changeCartItemWithRecovery(lineItem, currentKey, 0)
        .then(function() {
          dispatchCartBuild();
        })
        .catch(function(error) {
          notifyCartRequestError(error);
          delete lineItem.dataset.paveUpdating;
          select.disabled = false;
          select.value = String(currentOptionKey);
        });
      return;
    }

    if (!nextOption.variant_id || nextOption.available === false) {
      select.value = String(currentOptionKey);
      if (change) {
        setCartChangeState(change, false);
      }
      return;
    }

    lineItem.dataset.paveUpdating = 'true';
    select.disabled = true;
    var presentation = getOptionPresentation(nextOption);
    var item = {
      quantity: 1,
      id: Number(nextOption.variant_id),
      properties: {
        'Pave Option': presentation.title,
        '_cart_bundle_id': bundleId,
        '_cart_bundle_role': 'child',
        '_cart_parent_variant_id': parentVariantId || '',
        '_cart_child_label': 'ADD-ON',
        '_cart_child_title': presentation.title,
        '_cart_child_subtitle': presentation.subtitle,
        '_cart_child_image': presentation.image,
        '_cart_child_option_key': String(nextOption.key),
        '_cart_child_options': JSON.stringify(options),
        '_pave_bundle_id': bundleId,
        '_pave_role': 'child',
        '_pave_options': JSON.stringify(options),
        '_pave_option_key': String(nextOption.key),
        '_pave_parent_variant_id': parentVariantId || '',
        '_pave_option_subtitle': presentation.subtitle,
        '_pave_option_image': presentation.image
      }
    };

    addCartItem(item)
      .then(function() {
        return changeCartItemWithRecovery(lineItem, currentKey, 0);
      })
      .then(function() {
        dispatchCartBuild();
      })
      .catch(function(error) {
        notifyCartRequestError(error);
        delete lineItem.dataset.paveUpdating;
        select.disabled = false;
        select.value = String(currentOptionKey);
      });
  }

  function createBundleId() {
    return 'pave-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function appendBundleItem(items, parentItem, fallbackVariantId) {
    if (!Array.isArray(items) || !parentItem) {
      return '';
    }

    var selection = getSelection();
    var variantId = Number(fallbackVariantId || (selection && selection.variant_id));
    if (!variantId) {
      return '';
    }

    if (!selection || Number(selection.variant_id) !== variantId) {
      selection = {
        option_key: '',
        title: 'Pavé Diamond Bridge',
        variant_id: variantId,
        options: selection && Array.isArray(selection.options) ? selection.options : [],
        image: ''
      };
    }

    var existingProperties = parentItem.properties || {};
    var bundleId = existingProperties._cart_bundle_id || existingProperties._pave_bundle_id || createBundleId();
    var presentation = getOptionPresentation(selection);
    parentItem.properties = existingProperties;
    parentItem.properties._cart_bundle_id = bundleId;
    parentItem.properties._cart_bundle_role = 'parent';
    parentItem.properties._pave_bundle_id = bundleId;
    parentItem.properties._pave_role = 'parent';

    items.push({
      quantity: 1,
      id: variantId,
      properties: {
        'Pave Option': presentation.title,
        '_cart_bundle_id': bundleId,
        '_cart_bundle_role': 'child',
        '_cart_parent_variant_id': String(parentItem.id || ''),
        '_cart_child_label': 'ADD-ON',
        '_cart_child_title': presentation.title,
        '_cart_child_subtitle': presentation.subtitle,
        '_cart_child_image': presentation.image,
        '_cart_child_option_key': String(selection.option_key || ''),
        '_cart_child_options': JSON.stringify(selection.options || []),
        '_pave_bundle_id': bundleId,
        '_pave_role': 'child',
        '_pave_options': JSON.stringify(selection.options || []),
        '_pave_option_key': String(selection.option_key || ''),
        '_pave_parent_variant_id': String(parentItem.id || ''),
        '_pave_option_subtitle': presentation.subtitle,
        '_pave_option_image': presentation.image
      }
    });

    return bundleId;
  }

  function initCartControls() {
    document.querySelectorAll('[data-cart-line-item]').forEach(function(lineItem) {
      populateCartSelect(lineItem);
    });
  }

  function closeCartSelects(except) {
    document.querySelectorAll('[data-cart-change].is-active').forEach(function(change) {
      if (change !== except) {
        setCartChangeState(change, false);
      }
    });
  }

  function hideProductPickerDuringCartEdit() {
    var searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('edit_cart_id')) {
      return false;
    }

    document.querySelectorAll('[data-pave-option-picker]').forEach(function(wrapper) {
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
    });
    return true;
  }

  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-cart-change-toggle]');
    if (!toggle) {
      if (!event.target.closest('[data-cart-change]')) {
        closeCartSelects();
      }
      return;
    }
    var change = toggle.closest('[data-cart-change]');
    if (!change) {
      return;
    }
    closeCartSelects(change);
    setCartChangeState(change, true);
    var select = change.querySelector('[data-cart-change-select]');
    if (select) {
      populateCartSelect(toggle.closest('[data-cart-line-item]'));
      select.focus();
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.matches('[data-cart-change-select]')) {
      replaceCartChild(event.target.closest('[data-cart-line-item]'), event.target);
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeCartSelects();
    }
  });

  function init() {
    if (!hideProductPickerDuringCartEdit()) {
      initProductPickers();
    }
    initCartControls();
  }

  window.KavalriPaveOption = {
    getSelection: getSelection,
    clearSelection: function() { window.localStorage.removeItem(storageKey); },
    createBundleId: createBundleId,
    appendBundleItem: appendBundleItem
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:build', function() {
    window.setTimeout(initCartControls, 0);
  });
})(window, document);
/** InsCoder 2026-08-04 E + Pavé option selection and cart child replacement **/
